import React, { useEffect, useState } from "react";
import { Btns, FormContainer } from "./styled";
import { Modal, Button, Form, Input } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Method_POST_REST } from "../../../../../../../../service/api";

export function ModalEditarCredencial({
  isOpen,
  onClose,
  credencialAdicionalId,
  atualizarTelaCredenciais,
  idClient,
}) {
  const [loadings, setLoadings] = useState(false);
  const [idCredencial, setIdCredencial] = useState(null);
  const [isIdCliente, setIsItCliente] = useState("");

  const [newData, setNewData] = useState({
    codigo: "",
    id: "",
    senha: "",
    site: "",
    tipo: "",
  });

  useEffect(() => {
    consultar(credencialAdicionalId, idClient);
  }, []);

  const consultar = async (idCredencial, idClient) => {
    const url =
      "/portal/rest/cliente/empresa/credencial-acesso/adicional/consultar";
    const param = {
      empresa: {
        id: idClient,
      },
      id: idCredencial,
    };

    setIsItCliente(idClient);
    setIdCredencial(idCredencial);

    try {
      const response = await axios.post(url, param, { withCredentials: true });

      setNewData({
        ...newData,
        codigo: response.data.codigo,
        id: response.data.id,
        senha: response.data.senha,
        site: response.data.site,
        tipo: response.data.tipo?.id,
      });
    } catch {}
  };

  const salvarEdicao = async () => {
    const url = "/cliente/empresa/credencial-acesso/adicional/atualizar";
    const param = {
      empresa: {
        id: isIdCliente,
      },
      codigo: newData.codigo,
      id: idCredencial,
      senha: newData.senha,
      site: newData.site,
      tipo: {
        id: newData.tipo,
      },
    };
    try {
      await Method_POST_REST(url, param);
      toast.success("Credencial editada com sucesso!");
      await atualizarTelaCredenciais(idClient);
      onClose();
    } catch (error) {
      console.error("Erro no envio da credencial adicional:", error.message);
    } finally {
      setLoadings(false);
      clearForm();
    }
  };

  const handleChange = (field, value) => {
    setNewData((prev) => ({ ...prev, [field]: value }));
  };

  const clearForm = () => {
    setNewData({
      codigo: "",
      id: "",
      senha: "",
      site: "",
      tipo: "",
    });
  };

  return (
    <Form.Item>
      <Modal
        title="Adicionar Credencial"
        open={isOpen}
        onCancel={() => {
          onClose();
          clearForm();
        }}
        footer={[
          <>
            <Btns>
              <Button
                key="cancel"
                onClick={() => {
                  onClose();
                  clearForm();
                }}
              >
                Cancelar
              </Button>
              <Button className="btn" loading={loadings} onClick={salvarEdicao}>
                <SaveOutlined /> Salvar
              </Button>
            </Btns>
          </>,
        ]}
      >
        <FormContainer>
          <div style={{ display: "flex" }}>
            <div className="form-content" style={{display: "block", margin: 5}}>
              <label>Tipo</label>
              <Input
                value={newData.tipo}
                onChange={(e) => handleChange("tipo", e.target.value)}
              />
            </div>

            <div className="form-content" style={{display: "block", margin: 5}}>
              <label>Código</label>
              <Input
                placeholder={newData.codigo}
                value={newData.codigo}
                onChange={(e) => handleChange("codigo", e.target.value)}
              />
            </div>
          </div>

          <div style={{ display: "flex" }} >
            <div className="form-content" style={{display: "block", margin: 5}}>
              <label>Senha</label>
              <Input.Password
                placeholder={newData.senha}
                value={newData.senha}
                onChange={(e) => handleChange("senha", e.target.value)}
              />
            </div>

            <div className="form-content" style={{display: "block", margin: 5}}>
              <label>Site</label>
              <Input
                placeholder={newData.site}
                value={newData.site}
                onChange={(e) => handleChange("site", e.target.value)}
              />
            </div>
          </div>
        </FormContainer>
      </Modal>
    </Form.Item>
  );
}

export default ModalEditarCredencial;
